// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-dynamic-form-definition-request-schema',
  type: 'object',
  required: ['appSystemKey', 'id'],
  properties: {
    appSystemKey: {
      type: 'string',
    },
    id: {
      type: 'string',
    },
    businessUnit: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
